import { render, staticRenderFns } from "./CartForSingle.vue?vue&type=template&id=366f147d&scoped=true"
import script from "./CartForSingle.vue?vue&type=script&lang=js"
export * from "./CartForSingle.vue?vue&type=script&lang=js"
import style0 from "./CartForSingle.vue?vue&type=style&index=0&id=366f147d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366f147d",
  null
  
)

export default component.exports